import React, { useState } from "react";
import { LogoCenter } from "../../component/LogoCenter";
import arrowNext from "../../images/arrowNext.svg";
import smallArrow from "../../images/smallArrow.svg";
import { Link } from "react-router-dom";

const SignUpAthleteGoals: React.FC = () => {
  return (
    <div className={`p-[20px] bg-black h-dvh overflow-hidden `}>
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center  overflow-y-auto">
        <LogoCenter />
        <div className="flex flex-col gap-[50px] w-full">
          <div className="flex flex-col justify-center gap-[15px]">
            <h1 className="text-white text-[40px] leading-[95%] uppercase font-light">
              SET YOUR <br />
              goals
            </h1>
            <div className="rounded-[15px] flex flex-row gap-[15px]">
              <div className="w-1/2 border border-white rounded-[15px] p-5 flex flex-col justify-between">
                <label className="text-sm text-white font-normal leading-none mb-2">
                  100m PR
                </label>
                <p className="text-white font-light text-[40px] leading-none">
                  11.6<span className="text-2xl">s</span>
                </p>
              </div>
              <div className="w-1/2 border border-white rounded-[15px] p-5 flex flex-col justify-between">
                <label className="text-sm text-white font-normal leading-none mb-2">
                  100m PR
                </label>
                <p className="text-white font-light text-[40px] leading-none">
                  23.1<span className="text-2xl">s</span>
                </p>
              </div>
            </div>
            <div className="border border-white rounded-[15px] p-5 flex flex-col justify-between gap-[22px]">
              <label className="text-sm text-white font-normal leading-none">100m PR</label>
              <p className="text-white font-light text-[40px] leading-none">
                11.6<span className="text-2xl">s</span>
              </p>
            </div>
          </div>
          <div className="flex flex-row justify-between items-center">
            <p className="text-white text-[30px] font-light uppercase leading-none">
              get <br />
              <span className="font-bold">faster.</span>
            </p>
            <Link
              to="/dashboard"
              className="bg-white size-[70px] rounded-full flex justify-center items-center hover:bg-white/50 transition-all duration-300 ml-auto"
            >
              <img src={arrowNext} alt="arrow" className="object-contain" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpAthleteGoals;
